import { useMemo } from 'react'
import useMedia from 'use-media'
import { MediaQueryContext } from '@context'

const mediaQueries = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width:  1400px)',
  touch: '(hover: none)',
}

const MediaQuery = ({ children }) => {
  const xs = useMedia(mediaQueries.xs)
  const sm = useMedia(mediaQueries.sm)
  const md = useMedia(mediaQueries.md)
  const lg = useMedia(mediaQueries.lg)
  const xl = useMedia(mediaQueries.xl)
  const xxl = useMedia(mediaQueries.xxl)
  const touch = useMedia(mediaQueries.touch)

  const value = useMemo(
    () => ({ xs, sm, md, lg, xl, xxl, touch }),
    [xs, sm, md, lg, xl, xxl, touch]
  )

  return <MediaQueryContext.Provider value={value}>{children}</MediaQueryContext.Provider>
}

MediaQuery.defaultProps = {}
MediaQuery.propTypes = {}

export default MediaQuery
